<template>
  <div
    v-loading="loading"
    element-loading-text="请稍后..."
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.8)"
    class="hxgh-list-div"
  >
    <div class="line-list-div">
      <el-collapse v-model="activeNames">
        <el-collapse-item
          :key="index"
          v-for="(item, index) in lines"
          :title="item.line.title"
          :name="index + ''"
        >
          <div>
            <PublicForm
              :width="'100px'"
              :formData="item.line.formData"
              :formList="cols"
              :class="'road-from'"
            />
          </div>
          <div class="item-moni">
            <el-button @click="doFly(item)" class="base-button" size="mini" type="primary"
              >航线模拟</el-button
            >
            <el-button
              @click="doFlyBack(item)"
              class="base-button"
              size="mini"
              type="primary"
              >航线返航</el-button
            >
            <el-button @click="deleteById(item.id)" size="mini" type="danger"
              >删除航线</el-button
            >
          </div>
        </el-collapse-item>
      </el-collapse>
    </div>
    <!-- <div class="menu-bottom">
      <div @click="manageQuery" class="menu">
        <img src="../../assets/cx.png" />
        查询
      </div>
    </div> -->
  </div>
</template>
<script>
import {
  getZTreeGroupDevice,
  getlistDeviceLocation,
  deleteDeviceGroup,
} from "@/api/device/index.js";
import Pathplan from "../Roads/pathplan.vue"; //预案编辑
import { getCommonAjax } from "@/api/common";
import PathAnimation from "@/utils/cesiumBD/animation/PathAnimation";
let animationList = [];
import { deleteLine } from "@/api/line/index.js";
export default {
  data() {
    return {
      loading: false,
      lines: [],
      Listdata: [
        {
          id: 1,
          name: "监控中心",
          children: [],
        },
      ],
      defaultProps: {
        children: "children",
        label: "name",
      },
      allCards: [],
      activeNames: ["0"],
      formData: {},
      cols: [
        {
          label: "时间",
          cusprop: "timeStr",
          component: "popContent",
        },
        {
          label: "起点",
          cusprop: "start",
          component: "popContent",
        },
        {
          label: "起始经度",
          cusprop: "startLon",
          component: "popContent",
        },
        {
          label: "起始纬度",
          cusprop: "startLat",
          component: "popContent",
        },
        {
          label: "终点",
          cusprop: "end",
          component: "popContent",
        },
        {
          label: "终点经度",
          cusprop: "endLon",
          component: "popContent",
        },
        {
          label: "终点纬度",
          cusprop: "endLat",
          component: "popContent",
        },
        {
          label: "飞行高度(米)",
          cusprop: "height",
          component: "popContent",
        },
      ],
    };
  },
  created() {
    this.getList();
  },
  mounted() {
    this.$bus.$on("line-list-refresh", () => {
      this.getList();
    });
  },
  beforeDestroy() {
    this.$bus.$off("line-list-refresh");
    animationList.forEach((ani) => {
      ani.stop();
    });

    animationList = [];
  },
  methods: {
    deleteById(id) {
      this.$confirm("是否删除该条航线数据？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          deleteLine(id).then(() => {
            this.$message({
              showClose: true,
              message: "删除成功！",
              type: "success",
              duration: 3 * 1000,
            });
            this.getList();
          });
        })
        .catch(() => {
          this.$message({
            showClose: true,
            type: "info",
            message: "本次操作已取消！",
            duration: 3 * 1000,
          });
        });
    },
    doFlyBack(item) {
      if (item.animationHelp) {
        item.animationHelp.doBack();
        return;
      }
      let positions = item.line.formData.raisedPositions.reverse();
      let uuid = "返航" + item.id;
      var entity = viewer.entities.getById(uuid); //下标
      if (!entity) {
        entity = this.createFlydEntity(positions[0], uuid);
        viewer.entities.add(entity);
      }
      entity.fltPath = positions;

      var animation = new PathAnimation({
        surface: false,
        height: item.line.formData.height,
        entity: entity,
        positions: positions,
        speed: 340,
        multiple: 1,
      });
      animation.start();
      animationList.push(animation);
      viewer.zoomTo(entity);
    },
    doFly(item) {
      // this.$dialog.open({
      //   id: "航线模拟",
      //   title: "航线模拟",
      //   theme: "feature-dialog",
      //   area: {
      //     height: "360px",
      //     width: "400px",
      //   },
      //   location: {
      //     top: "80px",
      //     left: "20px",
      //   },
      //   content: {
      //     type: "vue",
      //     subCom: Pathplan,
      //     subData:item
      //   },
      // });
      let positions = item.line.formData.raisedPositions;
      let uuid = "模拟飞行" + item.id;
      var entity = viewer.entities.getById(uuid); //下标
      if (!entity) {
        entity = this.createFlydEntity(
          positions[0],
          uuid,
          this.setPositionsHeight(positions, item.line.formData.height)
        );
        viewer.entities.add(entity);
      }
      entity.fltPath = positions;

      var animation = new PathAnimation({
        surface: false,
        height: item.line.formData.height,
        entity: entity,
        positions: positions,
        speed: 340,
        multiple: 1,
      });
      animation.start();
      animationList.push(animation);
      viewer.zoomTo(entity);

      item.animationHelp = animation;
    },

    setPositionsHeight(positions, height) {
      height = Number(height) || 0;

      if (positions instanceof Array) {
        var arr = [];
        for (var i = 0, len = positions.length; i < len; i++) {
          var car = Cesium.Cartographic.fromCartesian(positions[i]);
          var point = Cesium.Cartesian3.fromRadians(car.longitude, car.latitude, height);
          arr.push(point);
        }
        return arr;
      } else {
        var car = Cesium.Cartographic.fromCartesian(positions);
        return Cesium.Cartesian3.fromRadians(car.longitude, car.latitude, height);
      }
    },
    createFlydEntity(center, uuid, positions) {
      // let lineCallback = [];
      // let lineCallbackProperty = new Cesium.CallbackProperty(function (time) {
      //   return lineCallback;
      // }, false); //圆锥高度

      const entity = new Cesium.Entity({
        id: uuid,
        position: center,
        model: {
          show: true,
          uri: "data/mx/feiji.glb", //模型的地址
          scale: 0.3, //模型缩放比例
          minimumPixelSize: modelMinimumPixelSize, //
          maximumScale: 20000, // 模型的最大比例尺大小。 minimumPixelSize的上限
          incrementallyLoadTextures: true, // 加载模型后纹理是否可以继续流入
          runAnimations: true, // 是否应启动模型中指定的glTF动画
          clampAnimations: true, // 指定glTF动画是否应在没有关键帧的持续时间内保持最后一个姿势
          shadows: Cesium.ShadowMode.ENABLED,
          heightReference: Cesium.HeightReference.NONE, //设置模型贴地,
        },
        polyline: {
          positions: positions,
          width: 10,
          material: new Cesium.PolylineArrowMaterialProperty(Cesium.Color.LIMEGREEN),
        },
      });

      //entity.lineCallback = lineCallback;
      return entity;
    },
    getList() {
      this.loading = true;
      getCommonAjax("/line/queryLineList", {})
        .then((res) => {
          console.log(res);
          this.loading = false;

          this.lines = res.result.map((l) => {
            l.line = JSON.parse(l.line);
            return l;
          });
        })
        .catch((err) => {
          this.loading = false;
          console.error(err);
        });
    },
    manageQuery() {
      this.$dialog.open({
        id: "航线查询",
        title: "航线查询",
        theme: "feature-dialog",
        area: {
          height: "560px",
          width: "400px",
        },
        location: {
          top: "80px",
          left: "20px",
        },
        content: {
          type: "vue",
          subCom: Pathplan,
        },
      });
    },
    commrecord() {},
  },
};
</script>
<style lang="scss">
.hxgh-list-div {
  padding: 0 16px;
  .line-list-div {
    height: 750px;
    max-height: 750px;
    overflow-y: auto;
  }
  .el-collapse .el-collapse-item {
    background: #dcdfe6;
  }

  .el-collapse .el-collapse-item .el-collapse-item__header {
    color: #097cf5;
    padding: 0 10px;
  }
  .item-moni {
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
</style>
<style lang="scss" scoped>
.carTree-div {
  height: 100%;
}

.search-top {
  margin-bottom: 0;
  text-align: center;
  .el-button--text {
    color: #000;
  }
}
.menu-bottom {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  .menu {
    width: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #424a6b;
    padding: 10px 0;
    cursor: pointer;
    img {
      width: 22px;
      height: 22px;
      margin: 0 6px;
    }
  }
}
</style>

<style lang="scss">
.custom-tree-node-card {
  width: 100%;
  display: flex;
  align-items: center;
  font-size: 12px;
}

.custom-tree-node-card .operate {
  margin-left: 10px;
}

.carTree-div {
  .el-tree {
    background: transparent;
    color: #ffffff;
    height: 700px;
    overflow-y: auto;

    .el-tree-node__content:hover,
    .el-upload-list__item:hover {
      background-color: transparent;
      color: #83e9ff;
    }

    .el-checkbox__inner {
      background-color: transparent;
    }
  }

  .el-tree--highlight-current .el-tree-node.is-current > .el-tree-node__content {
    background-color: transparent !important;
    color: #83e9ff !important;
  }

  .el-tree-node__expand-icon {
    color: #ffffff !important;
  }

  .el-tree-node:focus > .el-tree-node__content {
    background-color: transparent !important;
  }
}
</style>
